import actions from "@/modules/pe-basic-module/data/actions"
import { UPDATE_SINGLE_TYPE } from "@/modules/pe-basic-module/data/actionTypes"
import { IState, useMainStore } from "@/settings/zustand"
import { useUser } from "@/settings/zustand/user"
import { Button, Intent, Popover, Position, Tooltip } from "@blueprintjs/core"
import { Fragment, useState } from "react"
import { DIALOG_SIZE, IPost } from "../interfaces/layouts"
import { __ } from "../utilities" 
import AvatarLink from "./AvatarLink"
import { useDataStore } from "@/modules/pe-basic-module/data/store"
import ScalableDialog from "./ScalableDialog"
import { showToast } from "./AppToaster"

/* Protopia Ecosystem component */
export interface IBookmarkProps {
   item: IPost
   className?:string 
   onBookmark?: () => void
}
const Bookmark = ({item, ...props}: IBookmarkProps): JSX.Element => {
    const user = useUser()
    const landId = useMainStore((state: IState) => state.landId)
    const [isOpen, setIsOpen] = useState<boolean> (false)
    const [isMarked,setIsMarked] = useState<boolean>(!!item.bookmarks?.filter(b => b.id === user.id).length) 
    const onBookmark = async () => {
        if(!user.id) {
            useMainStore.setState({isOpenLogin: true})
            return
        }
        actions(UPDATE_SINGLE_TYPE, {
            landId: item.land_id || landId, 
            id: item.id,
            data_type: item.__typename, 
            item: {
                bookmarks: [ { add: !isMarked } ]
            }
        })
        .then(async (res: IPost) => {
            const is = !!res.bookmarks?.filter(b => b.id === user.id).length
            setIsMarked( is )
            useDataStore.setState({
                [ item.__typename || "Post" ]: [
                    ...useDataStore.getState()[ item.__typename || "Post"].map((itm: any) => {
                        if(itm.id === res.id) {
                            return res
                        }
                        return itm
                    })
                ]
            })
            if(props.onBookmark) {
                props.onBookmark()
            }
            showToast({
                message: is 
                    ? 
                    <div>
                        <div className="mb-1">
                            {__("You have subscribed.")}
                        </div>
                        <div className="descr">
                            {__("Now you will receive notifications every time new comments appear or the object is changed." )}
                        </div>
                    </div> 
                    : 
                    <div>
                        {__("You have unsubscribed" )}
                    </div>,
                timeout: 10000
            })
        })
    }

    const tooltip = <Tooltip content={ __(isMarked ? "Remove bookmark":  "Add bookmark") } position={Position.TOP} className="p-2">
        <Button variant="minimal" intent={Intent.NONE} onClick={ onBookmark } className={` ${ props.className ? props.className : "px-2" }`}  data-testid="bookmark-button">
            <span className="flex-centered ">
                <i className={ `${isMarked ? "text-danger fas" : "far"} fa-bookmark mr-1 `}></i> 
                <span className={ `${isMarked ? "text-danger " : ""}`}>{ item.bookmarks?.length || 0 }</span> 
            </span>
        </Button> 
    </Tooltip>
    return  !!item.bookmarks?.length 
        ?
        <Popover
            interactionKind="hover"
            hoverOpenDelay={ 1000 }
            position={Position.TOP}
            content={
                <div>
                    <div className="px-2 descr text-force-contrast">
                        {
                            isMarked
                                ?
                                __("You are subscribe this. Click for remove bookmark")
                                :
                                __("Click for subscribe")
                        }
                    </div>
                     <div className="short-container d-flex flex-wrap">
                        {
                            item.bookmarks?.filter(bk => !!bk.id).map((bk, i) => {
                                return i  <  4 
                                    ?
                                    <AvatarLink user={bk} selected={user} key={bk?.id || i} />
                                    :
                                    <Fragment key={"0"} />
                            })
                        }
                        {
                            item.bookmarks?.length > 4 && <Fragment >
                                <div className="flex-centered p-1 pe-w-100 pe-h-100 pointer" onClick={ () => setIsOpen(true) }>
                                    +{ item.bookmarks?.filter(bk => !!bk.id).length - 4 }
                                </div>
                                <ScalableDialog
                                    isOpen={isOpen}
                                    onClose={()=> setIsOpen(false)}
                                    hideClose={false}
                                    mayFullScreen
                                    dialogSize={DIALOG_SIZE.NORMAL}
                                >
                                    <div className="p-0 overflow-y-auto max-height">
                                        <div className="pt-2 px-2 text-center lead-md text-force-contrast">
                                            {__("All subscribers")}
                                        </div>
                                        <div className="p-4 flex-centered flex-wrap"> 
                                            {
                                                item.bookmarks?.filter(bk => !!bk.id).map((bk , i:number) => {
                                                    return <AvatarLink user={bk} selected={user} key={bk?.id || i} />  
                                                })
                                            }
                                        </div>
                                    </div>
                                </ScalableDialog>
                            </Fragment> 
                        }
                    </div>   
                </div> 
            }
        >
            {tooltip}
        </Popover>
        :
        tooltip
}
export default Bookmark